import { SVGProps } from 'react'

import { SearchInput } from 'components/SearchInput'
import { Box } from 'styled-system/jsx'
import { Icon } from 'ui-kit/icon'
import { Kbd, KbdProps } from 'ui-kit/kbd'

export function AlgoliaSidebarSearchPlaceholder({ onClick }) {
  return (
    <Box
      position='relative'
      onMouseDown={(event) => {
        event.preventDefault()
        onClick()
      }}
    >
      <SearchInput
        width={{
          base: '36',
          sm: '52',
          md: '72',
          lg: '96',
        }}
        height='10'
        fontSize='sm'
        backgroundColor='bg.muted'
        placeholder='Type to search'
      />
      <Box
        display={{
          base: 'none',
          sm: 'flex',
        }}
        position='absolute'
        top='0'
        bottom='0'
        right='2'
        flexDirection='row'
        alignItems='center'
        gap='0.5'
        fontSize='xs'
        lineHeight='normal'
        pointerEvents='none'
        color='fg.muted'
      >
        <StyledKbd className={'visible-on-mac'}>
          <Icon width='4' height='4'>
            <MacIcon />
          </Icon>
        </StyledKbd>
        <StyledKbd className={'visible-not-on-mac'}>Ctrl</StyledKbd>+
        <StyledKbd>K</StyledKbd>
      </Box>
    </Box>
  )
}

function MacIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox={'0 0 24 24'}
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}
    >
      <path d='M7 9a2 2 0 1 1 2-2v10a2 2 0 1 1-2-2h10a2 2 0 1 1-2 2V7a2 2 0 1 1 2 2H7' />
    </svg>
  )
}

function StyledKbd({ children, ...props }: KbdProps) {
  return (
    <Kbd
      fontSize='xs'
      color='fg.muted'
      borderRadius='l2'
      borderColor='border.muted'
      borderWidth='1px'
      backgroundColor='transparent'
      display='flex'
      alignItems='center'
      justifyContent='center'
      minWidth='6'
      height='6'
      line-height='1.5rem'
      paddingLeft='0.5'
      paddingRight='0.5'
      {...props}
    >
      {children}
    </Kbd>
  )
}
